<template>
  <div class="card"
    :class="{ 'is-large' : isLarge, 'has-outline' : hasOutline, 'is-transparent' : isTransparent }">
    <div v-if="$slots.title" class="card__title">
      <slot name="title"></slot>
    </div>
    <div class="card__body">
      <slot></slot>
    </div>
    <div v-if="$slots.footer" class="card__footer">
      <slot name="footer"></slot>
    </div>
    <div v-if="$slots.badge" class="card__badge">
      <slot name="badge"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    hasOutline: Boolean,
    isLarge: Boolean,
    isTransparent: Boolean,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card {
  padding: 30px;
  background: white;
  border-radius: var(--radius-large);
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  text-decoration: none;
  position: relative;
  &__title {
    margin-bottom: 10px;
    font-weight: 500;
    > * {
      margin: 0 0 5px;
    }
  }
  &__body {
    color: rgba(0,0,0,0.5);
  }
  &__footer {
    margin-top: 20px;
  }
  &__badge {
    background: var(--color-dark);
    color: white;
    border-radius: 40px 0px 0px 40px;
    padding: 6px 6px 6px 10px;
    font-size: var(--font-small);
    position: absolute;
    text-transform: capitalize;
    top: 20px;
    right: 0;
  }
  &.has-outline {
    background: transparent;
    box-shadow: none;
    border: 2px solid var(--color-dark);
    color: var(--color-dark);
  }
  &.is-transparent {
    background: transparent;
    box-shadow: 0 1px 0px 1px rgba(0,0,0,0.04);
  }
  &.is-large {
    .card__title {
      margin-bottom: 45px;
    }
    .card__footer {
      margin-top: 30px;
    }
  }
  a:hover & {
    color: var(--color-link);
    border-color: var(--color-link);
    text-decoration: none;
    &__body {
      color: var(--color-link);
    }
  }
}
</style>
